.definitionLink {
    font-style: italic;
}

.footnoteLink {
    font-size: 0.75em;
}

.iconButton {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: none;
    background: none;
    cursor: pointer;
    padding: 0;
    opacity: 0.6;
    transition: opacity var(--transition-duration-fast)
        var(--transition-ease-smooth);
    vertical-align: middle;

    &:hover {
        opacity: 1;
    }

    &:focus-visible {
        outline: 2px solid var(--mantine-color-gneis-9);
        outline-offset: 2px;
        border-radius: 2px;
    }
}
